import { Logger } from 'common/logger';
import { PATH_OPERATIONS } from 'common/constants';
import { mapValues, keyBy } from 'lodash';
import { rematchStore } from 'models/rematchStore';

export const EMPTY_SITE_DATA = { platforms: [], substations: [], locations: [], turbines: [] };

export const getSelectedItems = (state) => {
    const { selectedDate, selectedTurbineKey } = state.menuBar;
    const { selectedPark, selectedParkData } = state.appData;
    const selectedParkId = selectedParkData.id;

    return { selectedDate, selectedPark, selectedParkId, selectedTurbineKey };
};

export function findSelectedParkData() {
    const state = rematchStore.getState();
    const { selectedPark, parkData } = state.appData;

    if (!parkData || !parkData[selectedPark.toLowerCase()]) {
        Logger.debug('No parkData in getSelectedParkData');
        return EMPTY_SITE_DATA;
    }

    return parkData[selectedPark.toLowerCase()];
}

export const getSelectedParkData = () => {
    return rematchStore.getState().appData.selectedParkData;
};

export const getTurbineIdToNameMap = (state) => {
    const parkData = getSelectedParkData(state);

    const turbinesMap = mapValues(keyBy(parkData.turbines, 'id'), (v) => v.name);
    const platformsMap = mapValues(keyBy(parkData.platforms, 'id'), (v) => v.name);
    return { ...turbinesMap, ...platformsMap };
};

export function getLocation() {
    return rematchStore.getState().routing.pathname;
}

export function constructNewPathname(selectedPark = '', selectedScreen = '', previousPathname = '') {
    const screen = selectedScreen.toLowerCase();
    const selectedParkName = selectedPark.toLowerCase();
    const pathnamePrefix = `/${selectedParkName}/${screen}`;

    // if new screen use /park/screen otherwise keep sub-paths
    // also if operations screen use two paths as it has no sub paths
    if (!previousPathname.includes(screen) || screen === PATH_OPERATIONS) {
        return pathnamePrefix;
    }
    const previousPathnameParts = previousPathname
        .split('/')
        .slice(3)
        .join('/');
    return `${pathnamePrefix}/${previousPathnameParts}`;
}
